require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./works-2019-02-24-fortress.json") })
        }
      }, "path---works-2019-02-24-fortress");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---works-2019-02-24-fortress!./.cache/json/works-2019-02-24-fortress.json
// module id = 426
// module chunks = 231608221292675